// @flow

export default Object.freeze({
  GET_REVIEWS: 'GET_REVIEWS',
  GET_REVIEWS_ERROR: 'GET_REVIEWS_ERROR',
  GET_REVIEWS_START: 'GET_REVIEWS_START',
  GET_REVIEWS_SUCCESS: 'GET_REVIEWS_SUCCESS',
  GET_REVIEWS_RESET: 'GET_REVIEWS_RESET',
  GET_REVIEW_CATEGORIES: 'GET_REVIEW_CATEGORIES',
  GET_REVIEW_CATEGORIES_ERROR: 'GET_REVIEW_CATEGORIES_ERROR',
  GET_REVIEW_CATEGORIES_START: 'GET_REVIEW_CATEGORIES_START',
  GET_REVIEW_CATEGORIES_SUCCESS: 'GET_REVIEW_CATEGORIES_SUCCESS',
  GET_REVIEW_CATEGORIES_RESET: 'GET_REVIEW_CATEGORIES_RESET',
  CREATE_OR_UPDATE_RETORT: 'CREATE_OR_UPDATE_RETORT',
  CREATE_OR_UPDATE_RETORT_ERROR: 'CREATE_OR_UPDATE_RETORT_ERROR',
  CREATE_OR_UPDATE_RETORT_START: 'CREATE_OR_UPDATE_RETORT_START',
  CREATE_OR_UPDATE_RETORT_SUCCESS: 'CREATE_OR_UPDATE_RETORT_SUCCESS',
  CREATE_OR_UPDATE_RETORT_RESET: 'CREATE_OR_UPDATE_RETORT_RESET',
  MARK_REVIEWS_READ: 'MARK_REVIEWS_READ',
  MARK_REVIEWS_READ_ERROR: 'MARK_REVIEWS_READ_ERROR',
  MARK_REVIEWS_READ_START: 'MARK_REVIEWS_READ_START',
  MARK_REVIEWS_READ_SUCCESS: 'MARK_REVIEWS_READ_SUCCESS',
  MARK_REVIEWS_READ_RESET: 'MARK_REVIEWS_READ_RESET',
});



// WEBPACK FOOTER //
// ./src/modules/store/common/reviewsActionKeys.js